<chartjs-container [config]="chartConfig">
</chartjs-container>